import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { GET_AUDIT_LOGS_MOCK } from '@shared/mocks/audit-logs.mock';

import { AuditLogFilters, AuditLogsResponse } from './interfaces/audit-logs.interfaces';

import { HttpInterceptor } from '@interceptors/http/http.interceptor';

@Injectable({ providedIn: 'root' })
export class AuditLogsService {
  private readonly http = inject(HttpInterceptor);
  private readonly apiUrl = 'audit-logs';

  public getAuditLogs(page: number, pageSize: number, filters: AuditLogFilters = {}): Observable<AuditLogsResponse> {
    return this.http.get(this.apiUrl, GET_AUDIT_LOGS_MOCK, undefined, { page, pageSize, ...this.removeEmptyFilters(filters) });
  }

  private removeEmptyFilters(filters: AuditLogFilters): Record<string, string> {
    return Object.fromEntries(
      Object.entries(filters).filter((filterEntry): filterEntry is [string, string] => typeof filterEntry[1] === 'string' && filterEntry[1].length > 0),
    );
  }
}
